import React from 'react'
const Footer = ({currentPage}) => {
    return (
        <div style={{backgroundColor: `${currentPage? '#1C365E': 'white'}`}}>
             <footer>
            <p style={{color: `${currentPage? 'white': '#1C365E'}`}}>Copyright © Ricta Technologies SRL 2022. All rights reserved</p>
            <ul>
                <li><a style={{color: `${currentPage? 'white': '#1C365E'}`}}href="/privacyPolicy">Privacy |</a></li>
                <li><a style={{color: `${currentPage? 'white': '#1C365E'}`}} href="/cookies">Cookies |</a></li>
                <li><a style={{color: `${currentPage? 'white': '#1C365E'}`}} href="/termsOfService">Terms and conditions of use |</a></li>
                <li><a style={{color: `${currentPage? 'white': '#1C365E'}`}} href="/legalNotice">Legal Notice</a></li>
            </ul>
        
    </footer>
        </div>
    )
}
export default Footer